export const ANSWER = Object.freeze({
  Positive: 'Yes',
  Negative: 'No'
});
